// @flow

import type { Action } from './store.type';

export const INITIAL_MULTI_LEVEL_TAGS = 'INITIAL_MULTI_LEVEL_TAGS';
type INITIAL_MULTI_LEVEL_TAGS_TYPE = 'INITIAL_MULTI_LEVEL_TAGS';

export const UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS = 'UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS';
type UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS_TYPE = 'UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS';

type InitialMultiLevelTagsAction = Action<INITIAL_MULTI_LEVEL_TAGS_TYPE, null>;
type UpdateManualValuesMultiLevelTagsAction = Action<
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS_TYPE,
  null
>;

export const INITIAL_MULTI_LEVEL_COLLECTIONS = 'INITIAL_MULTI_LEVEL_COLLECTIONS';
type INITIAL_MULTI_LEVEL_COLLECTIONS_TYPE = 'INITIAL_MULTI_LEVEL_COLLECTIONS';

export const UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS =
  'UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS';
type UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS_TYPE =
  'UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS';

type InitialMultiLevelCollectionsAction = Action<INITIAL_MULTI_LEVEL_COLLECTIONS_TYPE, null>;
type UpdateManualValuesMultiLevelCollectionsAction = Action<
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS_TYPE,
  null
>;

export type MultiLevelAction =
  | InitialMultiLevelTagsAction
  | UpdateManualValuesMultiLevelTagsAction
  | InitialMultiLevelCollectionsAction
  | UpdateManualValuesMultiLevelCollectionsAction;

export type MultiLevelState = {
  loading: boolean,
  success: boolean,
  error: any,
  multiLevelTags: []
};
